// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"edbc2288","156":"5c4ced56","873":"48394aa8"}[chunkId] + ".chunk.css";
};